export const ScheduleDValidationMessages = {
    exceededMaximumFixedLocations:
        'Exceeded the maximum number of fixed locations (6)',
} as const;
